export default __webpack_public_path__ + "static/media/login-img-two.05928792.svg";